import { render, staticRenderFns } from "./AddTagToUser.vue?vue&type=template&id=6070cd97&"
import script from "./AddTagToUser.vue?vue&type=script&lang=js&"
export * from "./AddTagToUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports